import { ArrowBack } from '@mui/icons-material';
import { Box, Link, Typography } from '@mui/material';
import React, { useCallback, useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { ReactComponent as EmailSentIcon } from '../../assets/images/email-sent.svg';
import { LOGIN_CONTENT_MAX_WIDTH, MAGIC_LINK_EMAIL_STORAGE_KEY } from '../../constants/auth';
import { routes } from '../../constants/routing';
import LoginPageLayout from './LoginPageLayout';

const CheckInboxContainer = () => {
  const email = useMemo(() => localStorage.getItem(MAGIC_LINK_EMAIL_STORAGE_KEY), []);

  const handleBackClick = useCallback(() => {
    localStorage.removeItem(MAGIC_LINK_EMAIL_STORAGE_KEY);
  }, []);

  return (
    <LoginPageLayout>
      <Box sx={{ width: '100%', maxWidth: LOGIN_CONTENT_MAX_WIDTH }}>
        <Box
          sx={{
            mt: 8,
            mb: 4,
            display: 'flex',
            justifyContent: 'center',
            '& svg': { width: 100, height: 'auto' },
          }}
        >
          <EmailSentIcon />
        </Box>

        <Typography component="h1" variant="h4" align="center" sx={{ mb: 2 }}>
          Check your inbox
        </Typography>

        <Typography variant="body2" color="text.secondary" fontWeight="medium" sx={{ mb: 3 }}>
          {email ? (
            <>
              We sent a sign-in link to{' '}
              <Typography component="span" variant="body2" fontWeight="bold" color="text.primary">
                {email}
              </Typography>
              . Click the link in the email to finish signing in. The link expires in 6 hours.
            </>
          ) : (
            <>
              We sent you a sign-in link. Click the link in the email to finish signing in. The link expires in 6 hours.
            </>
          )}
        </Typography>

        <Box sx={{ textAlign: 'center' }}>
          <Link
            component={RouterLink}
            to={routes.login}
            onClick={handleBackClick}
            underline="none"
            sx={{
              mt: 2,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.5,
              color: 'primary.main',
              typography: 'body2',
              fontWeight: 'medium',
            }}
          >
            <ArrowBack fontSize="small" />
            Back to login
          </Link>
        </Box>
      </Box>
    </LoginPageLayout>
  );
};

export default CheckInboxContainer;
